(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('SeekingGenderDialogController', SeekingGenderDialogController);

    SeekingGenderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SeekingGender'];

    function SeekingGenderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SeekingGender) {
        var vm = this;

        vm.seekingGender = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.seekingGender.id !== null) {
                SeekingGender.update(vm.seekingGender, onSaveSuccess, onSaveError);
            } else {
                SeekingGender.save(vm.seekingGender, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('publicGatewayApp:seekingGenderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
